import { Badge } from "@/components/ui/badge"
import { testIds } from "@/lib/test-ids"
import { cn } from "@/lib/utils"

export type SkillDocumentBadgeProps = {
  tier?: string | null
  category?: string | null
}

const TIER_LABELS: Record<string, string> = {
  workspace: "Workspace skill",
  user: "Personal skill",
  platform: "Platform skill (git-managed)",
}

const TIER_COLORS: Record<string, string> = {
  workspace: "bg-blue-500/10 text-blue-500 border-blue-500/20",
  user: "bg-purple-500/10 text-purple-500 border-purple-500/20",
  platform: "bg-gray-500/10 text-gray-500 border-gray-500/20",
}

/**
 * Light chrome strip for skill documents (frontmatter.kind / document_type = 'skill').
 * Badge only - no form. Editing happens in the normal markdown/CodeMirror editor.
 * Precedent: KnowledgeHubStatusStrip (same isActive-gated placement in document-viewer.tsx).
 */
export function SkillDocumentBadge({ tier, category }: SkillDocumentBadgeProps) {
  const tierKey = (tier || "workspace").toLowerCase()
  const label = TIER_LABELS[tierKey] || "Skill"
  const colorClass = TIER_COLORS[tierKey] || "bg-muted text-muted-foreground border-border"

  return (
    <div
      className="flex h-11 shrink-0 items-center gap-2 border-b border-border bg-muted/20 px-3"
      data-testid={testIds.skills.documentBadge}
    >
      <Badge className={cn("border text-xs", colorClass)}>{label}</Badge>
      {category ? (
        <span className="text-xs text-muted-foreground truncate">{category}</span>
      ) : null}
    </div>
  )
}
